import { PayoutFrequencyOptions } from "@/Common/constants/PayoutFrequencyOptions";
import { DrawModalityEnum } from "@/Common/enums/DrawModalityEnum";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { tableSmartSelectorClasses, tableSmartSelectorListBoxProps, tableSmartSelectorPopperProps } from "@/styles/TableSmartSelector";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const payoutFrequencyOptions = Object.entries(PayoutFrequencyOptions).map(([value, { label }]) => ({ value, label }));

const isOptionDisabled = (optionValue, drawModality) => {
	if (!drawModality) return true;

	let disabled = false;
	const { PAY_PERIOD, COMMISSION_CYCLE } = PayoutFrequencyOptions;

	if (optionValue === PAY_PERIOD.value) {
		disabled = ![
			DrawModalityEnum.COMMISSION_ONLY_NO_DRAW, 
			DrawModalityEnum.COMMISSION_DRAW
		].includes(drawModality);
	} else if (optionValue === COMMISSION_CYCLE.value) {
		disabled = ![
			DrawModalityEnum.FLAT_DRAW, 
			DrawModalityEnum.HOURLY_DRAW, 
			DrawModalityEnum.COMMISSION_DRAW
		].includes(drawModality);
	}

	return disabled;
};

export default function PayoutFrequencySelector({ value, drawModality, onChange, ...props }) {
	const [selected, setSelected] = useState();

	useEffect(() => {
		setSelected(payoutFrequencyOptions.find((opt) => opt.value === value));
	}, [value]);

	const handleChange = (selected) => {
		setSelected(selected);
		onChange?.(selected?.value);
	};

	const disabledOptions = payoutFrequencyOptions
		.filter(({ value: optionValue }) => isOptionDisabled(optionValue, drawModality))
		.map((opt) => opt.value);

	return (
		<SmartSelector
			{...props}
			showBy="label"
			sortBy="label"
			options={payoutFrequencyOptions}
			disabledOptions={disabledOptions}
			selected={selected}
			selectBy="value"
			inputProps={{
				placeholder: "Frequency",
				classes: tableSmartSelectorClasses,
			}}
			listBoxProps={tableSmartSelectorListBoxProps}
			popperProps={tableSmartSelectorPopperProps}
			onChangeAction={handleChange}
		/>
	);
}

PayoutFrequencySelector.propTypes = {
	value: PropTypes.string,
	drawModality: PropTypes.oneOf(Object.values(DrawModalityEnum)),
	onChange: PropTypes.func,
};
